import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "contentHeader flex" }
const _hoisted_2 = {
  key: 0,
  class: "contentBox"
}
const _hoisted_3 = { class: "block w-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "grid grid-cols-2 gap-4 w-full" }
const _hoisted_6 = { class: "inputTitle" }
const _hoisted_7 = { class: "inputField flex-grow" }
const _hoisted_8 = { class: "inputTitle" }
const _hoisted_9 = { class: "inputField flex-grow" }
const _hoisted_10 = { class: "inputTitle" }
const _hoisted_11 = { class: "inputField flex-grow" }
const _hoisted_12 = { class: "inputTitle" }
const _hoisted_13 = { class: "inputField flex-grow" }
const _hoisted_14 = { class: "inputTitle" }
const _hoisted_15 = { class: "inputField flex-grow" }
const _hoisted_16 = { class: "inputTitle" }
const _hoisted_17 = { class: "inputField flex-grow" }
const _hoisted_18 = { class: "contentBox" }
const _hoisted_19 = { class: "block w-full" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "grid grid-cols-2 gap-4 w-full" }
const _hoisted_22 = { class: "inputTitle" }
const _hoisted_23 = { class: "inputField flex-grow" }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "inputTitle" }
const _hoisted_26 = { class: "inputField flex-grow" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", { value: "de" }, "Deutsch", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("option", { value: "en" }, "Englisch", -1)
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { class: "contentBox" }
const _hoisted_31 = { class: "block w-full" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = { class: "grid grid-cols-2 gap-4 w-full" }
const _hoisted_34 = { class: "inputTitle" }
const _hoisted_35 = { class: "inputField flex-grow" }
const _hoisted_36 = ["disabled", "placeholder"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = { class: "error-msg" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_40 = { class: "inputTitle" }
const _hoisted_41 = { class: "inputField flex-grow" }
const _hoisted_42 = ["disabled", "placeholder"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_44 = { class: "error-msg" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_46 = { class: "inputTitle" }
const _hoisted_47 = { class: "inputField flex-grow" }
const _hoisted_48 = ["disabled", "placeholder"]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_50 = { class: "error-msg" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_52 = ["disabled"]
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "lds-ring" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = { class: "smallText mt-4" }
const _hoisted_58 = { class: "contentBox" }
const _hoisted_59 = { class: "block w-full" }
const _hoisted_60 = { class: "grid grid-cols-2 gap-4 w-full" }
const _hoisted_61 = ["disabled"]
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "lds-ring" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1)
const _hoisted_65 = [
  _hoisted_64
]

import {useSystemStore} from '@/stores/system/SystemStore'
import getBrowserLocale from '@/utilities/system/helpers/GetBrowserLanguage'
import {ErrorLocationType, PreferenceType} from '@/utilities/system/enums/Enums';
import {helpers, required, sameAs} from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import {computed, onMounted, reactive, Ref, ref} from "vue";
import {$t, i18n} from "@/utilities/system/i18n/config";
import Error from "@/components/system/Error.vue";
import moment from 'moment';
import router from '@/router';
import ErrorHandler from "@/utilities/system/helpers/ErrorHandler";
import {UserPreference} from "@/models/system/user/UserPreference";
import {forbiddenStartupRouteNames} from "@/AppConfig";
import {RouteRecordNormalized} from "vue-router";
import {UserService} from "@/utilities/services/entities/UserService";
import OAuthService from "@/utilities/system/services/OAuthService";
import {useI18n} from "vue-i18n";
import {MiscService} from "@/utilities/system/services/entities/MiscService";
import {EncryptionService} from "@/utilities/services/EncryptionService";
import PolicyHelper from "@/utilities/system/helpers/PolicyHelper";
import PermissionService from "@/utilities/system/services/PermissionService";



export default /*#__PURE__*/_defineComponent({
  __name: 'Account',
  setup(__props) {

const { t } = useI18n();
const systemStore = useSystemStore();
const userService = new UserService();
const miscService = new MiscService()
const encryptionService = new EncryptionService()

let showChangePasswordError = ref(false);
const loading:Ref<boolean> = ref(false);
const availableRoutes:Ref<RouteRecordNormalized[]> = ref([]);

const convertedUserRoles = computed(()=>{
  return systemStore.user?.roles.map(r => t(`general.roles.${r}`))
})

const passwordChangedMoment = computed(()=>{
  return moment(systemStore.user?.lastPasswordChange).format('DD.MM.YYYY HH:mm') ?? ""
})

const form = reactive({
  oldPassword: '',
  newPassword: '',
  confirmPassword: '',
})
const newPasswordRules = computed(() => {
  return {
    oldPassword: { required: helpers.withMessage(t('validators.required'), required), },
    newPassword: { required: helpers.withMessage(t('validators.required'), required), },
    confirmPassword: {
      required: helpers.withMessage(t('validators.required'), required),
      sameAsPassword: helpers.withMessage(t('validators.sameAs'), sameAs(form.newPassword)),
    },
  }
})
const v$ = useVuelidate(newPasswordRules, form);


const changeUserStartPage = async({target}:any)=>{
  systemStore.userPreferences.general.userStartPage = target.value;

  await updateGeneralPreferences();

  systemStore.showSuccess($t('account.startPageSaved'));
}

const changeUserLocale = async({target}:any)=>{
  systemStore.userPreferences.general.userLocale = target.value;
  i18n.global.locale.value = target.value;

  await updateGeneralPreferences();

  systemStore.showSuccess($t('settings.languageSaved'));
}

const updateGeneralPreferences = async ()=>{
  const prefList = [];

  // go through general prefs in systemStore and use reflection to fill array with UserPreference objects
  for (const keyValueArray of Object.entries(systemStore.userPreferences.general)){
    // skip darkMode if it is set to FALSE to make automatism in Login.vue work
    if(keyValueArray[0] === "darkMode" && !keyValueArray[1]) continue;

    let converted = new UserPreference();
    converted.attributeName = keyValueArray[0];
    // @ts-expect-error
    converted.attributeValue = keyValueArray[1];

    prefList.push(converted);
  }

  // @ts-expect-error
  const preferenceUpdateResp = await userService.setUserPreferences(systemStore.user.id, PreferenceType.general, "", false, prefList);
  if (preferenceUpdateResp === null || preferenceUpdateResp === undefined || preferenceUpdateResp.statusCode !== 0){
    ErrorHandler.handleError(preferenceUpdateResp , ErrorLocationType.account);
    return;
  }
}

const isValidStartUpPage = (route:any) => {
  return !forbiddenStartupRouteNames.includes(route.name);
}

const isPermittedForRoute = (route:any) => {
  if(route.name === "Account") return true;
  if(route.name === "ProviderDetails") return false;
  const permissionString = PolicyHelper.getPolicyFromRoute(route.path);
  return PermissionService.userHasPermission(permissionString);
}

const logoutUser = async () =>{
  loading.value = true;
  const oAuthService = OAuthService.getDefaultInstance();

  systemStore.user = null;
  await oAuthService.logout();
};

const setNewPassword = async () => {
  loading.value = true;
  showChangePasswordError.value = false;

  const isFormCorrect = await v$.value.$validate()
  if (!isFormCorrect) {
    loading.value = false;
    return
  }

  const pubKey = await miscService.getPubKey(ErrorLocationType.account)
  if(!pubKey) return //TODO show error

  const current = await encryptionService.encrypt(form.oldPassword, pubKey)
  const changed = await encryptionService.encrypt(form.newPassword, pubKey)
  const changedRep = await encryptionService.encrypt(form.confirmPassword, pubKey)

  const resp = await userService.putChangePassword(systemStore.user!.id, current, changed, changedRep, ErrorLocationType.account);
  if(!resp){
    showChangePasswordError.value = true;

    loading.value = false;
    return
  }

  systemStore.showSuccess(t('account.passwordReset'));
  loading.value = false;
  form.oldPassword = "";
  form.newPassword = "";
  form.confirmPassword = "";
  v$.value.$reset();

  await updateUserInGlobalStore();
}

const updateUserInGlobalStore = async ()=>{
  const user = await userService.getUserById(systemStore.user.id, ErrorLocationType.account);
  if(!user) return;

  systemStore.setUser(user);
}

onMounted(async ()=>{
  availableRoutes.value = router.getRoutes()
      .filter(or => isValidStartUpPage(or))
      .filter(r => isPermittedForRoute(r))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h4", null, _toDisplayString(_unref($t)('account.myAccount')), 1)
      ]),
      (_unref(systemStore).user != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h4", null, _toDisplayString(_unref($t)('account.user')), 1),
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_unref($t)('account.firstName')), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(systemStore).user.firstName) = $event)),
                      class: "w-full",
                      id: "firstName"
                    }, null, 512), [
                      [_vModelText, _unref(systemStore).user.firstName]
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_unref($t)('account.lastName')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(systemStore).user.lastName) = $event)),
                      class: "w-full",
                      id: "lastName"
                    }, null, 512), [
                      [_vModelText, _unref(systemStore).user.lastName]
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_unref($t)('account.email')), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(systemStore).user.email) = $event)),
                      class: "w-full",
                      id: "email"
                    }, null, 512), [
                      [_vModelText, _unref(systemStore).user.email]
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_unref($t)('account.username')), 1),
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(systemStore).user.email) = $event)),
                      class: "w-full",
                      id: "username"
                    }, null, 512), [
                      [_vModelText, _unref(systemStore).user.email]
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_unref($t)('account.roles')), 1),
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((convertedUserRoles).value = $event)),
                      class: "w-full",
                      id: "roles"
                    }, null, 512), [
                      [_vModelText, convertedUserRoles.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_unref($t)('account.kid')), 1),
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(systemStore).user.ssoIdentifier) = $event)),
                      class: "w-full",
                      id: "ssoIdentifier"
                    }, null, 512), [
                      [_vModelText, _unref(systemStore).user.ssoIdentifier]
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("h4", null, _toDisplayString(_unref($t)('account.settings')), 1),
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_22, _toDisplayString(_unref($t)('account.startpage')), 1),
              _createElementVNode("div", _hoisted_23, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(systemStore).userPreferences.general.userStartPage) = $event)),
                  onChange: changeUserStartPage,
                  id: "userStartPage"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableRoutes.value, ({path, name}) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: path,
                      key: path
                    }, _toDisplayString(_unref($t)(`sidebar.${name}`)), 9, _hoisted_24))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _unref(systemStore).userPreferences.general.userStartPage]
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_25, _toDisplayString(_unref($t)('account.language')) + " (" + _toDisplayString(_unref($t)('account.browserLanguage')) + ": " + _toDisplayString(_unref(getBrowserLocale)()) + " (" + _toDisplayString(_unref(getBrowserLocale)({ countryCodeOnly: true })) + ")) ", 1),
              _createElementVNode("div", _hoisted_26, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(systemStore).userPreferences.general.userLocale) = $event)),
                  onChange: changeUserLocale,
                  id: "userLocale"
                }, _hoisted_29, 544), [
                  [_vModelSelect, _unref(systemStore).userPreferences.general.userLocale]
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("h4", null, _toDisplayString(_unref($t)('account.passwordTitle')), 1),
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_34, _toDisplayString(_unref($t)('account.passwordCurrent')), 1),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", {
                  class: _normalizeClass({ error: _unref(v$).oldPassword.$errors.length })
                }, [
                  _withDirectives(_createElementVNode("input", {
                    disabled: loading.value,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.oldPassword) = $event)),
                    class: "form-control w-full",
                    type: "password",
                    placeholder: _unref(t)('account.passwordTitle'),
                    autocomplete: "old-password",
                    required: "",
                    id: "passwordCurrent"
                  }, null, 8, _hoisted_36), [
                    [_vModelText, form.oldPassword]
                  ]),
                  _hoisted_37,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).oldPassword.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "input-errors",
                      key: error.$uid
                    }, [
                      _createElementVNode("div", _hoisted_38, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128))
                ], 2)
              ]),
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, _toDisplayString(_unref($t)('account.passwordNew')), 1),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", {
                  class: _normalizeClass({ error: _unref(v$).newPassword.$errors.length })
                }, [
                  _withDirectives(_createElementVNode("input", {
                    disabled: loading.value,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.newPassword) = $event)),
                    class: "form-control w-full",
                    type: "password",
                    placeholder: _unref(t)('account.passwordNew'),
                    autocomplete: "new-password",
                    required: "",
                    id: "passwordNew"
                  }, null, 8, _hoisted_42), [
                    [_vModelText, form.newPassword]
                  ]),
                  _hoisted_43,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).newPassword.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "input-errors",
                      key: error.$uid
                    }, [
                      _createElementVNode("div", _hoisted_44, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128))
                ], 2)
              ]),
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, _toDisplayString(_unref($t)('account.passwordRepeat')), 1),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", {
                  class: _normalizeClass({ error: _unref(v$).confirmPassword.$errors.length })
                }, [
                  _withDirectives(_createElementVNode("input", {
                    disabled: loading.value,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.confirmPassword) = $event)),
                    class: "form-control w-full",
                    type: "password",
                    placeholder: _unref(t)('account.passwordNew'),
                    autocomplete: "new-password",
                    required: "",
                    id: "passwordRepeat"
                  }, null, 8, _hoisted_48), [
                    [_vModelText, form.confirmPassword]
                  ]),
                  _hoisted_49,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).confirmPassword.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "input-errors",
                      key: error.$uid
                    }, [
                      _createElementVNode("div", _hoisted_50, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128))
                ], 2)
              ]),
              _createVNode(Error, {
                errorLoc: _unref(ErrorLocationType).account,
                class: "mt-4"
              }, null, 8, ["errorLoc"]),
              _hoisted_51,
              _createElementVNode("button", {
                disabled: loading.value,
                onClick: setNewPassword,
                class: _normalizeClass(["btn", loading.value ? 'disabled' : 'primary']),
                id: "setNewPassword"
              }, [
                (!loading.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_unref($t)('account.passwordResetButton')), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_54, _hoisted_56))
              ], 10, _hoisted_52),
              _createElementVNode("div", _hoisted_57, _toDisplayString(_unref($t)('account.lastPasswordChangeText')) + ": " + _toDisplayString(passwordChangedMoment.value), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_58, [
      _createElementVNode("div", _hoisted_59, [
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              disabled: loading.value,
              onClick: logoutUser,
              class: _normalizeClass(["btn", loading.value ? 'disabled' : 'primary']),
              id: "logoutUser"
            }, [
              (!loading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_unref($t)('account.logout')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_63, _hoisted_65))
            ], 10, _hoisted_61)
          ])
        ])
      ])
    ])
  ], 64))
}
}

})